import React, { useState } from 'react';
import { Phone, Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';

const ContactModal = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const handlePhoneClick = (phoneNumber) => {
    window.location.href = `tel:${phoneNumber}`;
  };

  const handleEmailClick = (email) => {
    window.location.href = `mailto:${email}`;
  };

  return (
    <>
      <Button
        className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white text-sm font-semibold rounded-full px-6 py-2.5 hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 shadow-md hover:shadow-lg"
        onClick={() => setIsContactModalOpen(true)}
        aria-label="Open contact modal"
      >
        Contact Us
      </Button>

      <Dialog
        open={isContactModalOpen}
        onOpenChange={setIsContactModalOpen}
        aria-labelledby="contact-modal-title"
      >
        <DialogContent className="sm:max-w-md w-full bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-6 transition-all duration-300">
          <DialogHeader>
            <DialogTitle
              id="contact-modal-title"
              className="text-2xl font-bold text-gray-900 dark:text-white"
            >
              Get in Touch
            </DialogTitle>
          </DialogHeader>
          <div className="grid gap-6 py-6">
            <div className="grid gap-3">
              <div className="flex items-center gap-3">
                <Phone className="h-6 w-6 text-blue-500" />
                <span className="font-semibold text-lg text-gray-900 dark:text-gray-100">
                  Phone Numbers
                </span>
              </div>
              <div className="flex flex-col gap-2 pl-8">
                {['9671966994', '9205254090', '9205254909'].map((phone, index) => (
                  <Button
                    key={index}
                    variant="ghost"
                    className="justify-start text-base text-gray-700 dark:text-gray-200 hover:bg-blue-50 dark:hover:bg-gray-700 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200 rounded-lg"
                    onClick={() => handlePhoneClick(phone)}
                    aria-label={`Call ${phone}`}
                  >
                    {phone}
                  </Button>
                ))}
              </div>
            </div>
            <div className="grid gap-3">
              <div className="flex items-center gap-3">
                <Mail className="h-6 w-6 text-blue-500" />
                <span className="font-semibold text-lg text-gray-900 dark:text-gray-100">
                  Email
                </span>
              </div>
              <Button
                variant="ghost"
                className="justify-start text-base text-gray-700 dark:text-gray-200 hover:bg-blue-50 dark:hover:bg-gray-700 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200 rounded-lg pl-8"
                onClick={() => handleEmailClick('qiktrack@gmail.com')}
                aria-label="Email qiktrack@gmail.com"
              >
                qiktrack@gmail.com
              </Button>
            </div>
          </div>
          <DialogFooter>
            <Button
              variant="outline"
              className="border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full px-6 py-2 transition-all duration-200"
              onClick={() => setIsContactModalOpen(false)}
              aria-label="Close contact modal"
            >
              Close
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ContactModal;